<template>
  <div class="keyUsers">
    <h1>{{ $t("keyUser.title") }}</h1>
    <div class="row">
      <div class="col-md-12 text-right">
        <button class="btn-download mr-5">
          {{ $t("events.listEvents.donwloadBtn") }}
        </button>
        <router-link
          class="btn-download"
          :to="{
            name: 'KeyUser Add'
          }"
          >{{ $t("keyUser.newKeyUser") }}</router-link
        >
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <v-client-table
          :columns="table_options.columns"
          :options="table_options.options"
          :data="keyUsers"
        >
          <template #actions="props">
            <i class="far fa-eye"></i>
          </template>
        </v-client-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keyUsers: []
    };
  },
  methods: {},
  computed: {
    appLang: function() {
      return this.$store.getters["settings/currentLang"];
    },
    userTable: function() {
      return this.$refs.keyUserTable;
    },
    table_headings: function() {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach(column => {
          headings[column] = this.$t(`keyUser.table.headings.${column}`);
        });
        return headings;
      }
      return null;
    },
    table_options: function() {
      return {
        columns: ["name", "controlNumber", "email", "rol", "actions"],
        options: {
          texts: {
            filter: `${this.$t("keyUser.searchKeyUser")}:`,
            filterPlaceholder: this.$t("keyUser.searchKeyUserPlaceholder")
          },
          headings: this.table_headings,
          sortable: ["name"],
          filterable: ["name", "controlNumber"],
          sortIcon: {
            base: "fas",
            up: "fa-sort-up",
            down: "fa-sort-down",
            is: "fa-sort"
          },
          columnsClasses: {
            name: "name-column",
            controlNumber: "controlNumber-column",
            email: "email-column",
            rol: "rol-column",
            actions: "actions-column"
          },
          resizableColumns: false
        }
      };
    }
  }
};
</script>

<style>
.keyUsers .btn-download {
  padding: 0.7rem 2rem;
  background: #000;
  color: #fff;
  border: none;
  border-radius: 0px;
}
.keyUsers .form-inline label {
  display: initial;
}
</style>
